import { gql } from "@apollo/client";

export const PROJECT_RUN = gql`
  query RunNode($where: RunNodeWhereInput) {
    runNode(where: $where) {
      id
      status
      context
      subjectType
      subjectId
      project {
        id
      }
      process {
        id
      }
      currentNode {
        id
        name
        tag
        order
        progress
        nodeType
        formDefinition
        config
        possibleStatuses {
          id
          kind
          event
          nextStatus
          order
        }
        screens {
          id
          currentPublishedVersion {
            id
            versionNumber
            status
            htmlContent
            styleContent
            bindingManifest {
              id
              slots
            }
            translationTable {
              id
              entries
            }
            states {
              id
              name
              order
              htmlContent
              conditions
              bindingManifest {
                id
                slots
              }
            }
          }
        }
      }
      children {
        id
        status
        subjectType
        subjectId
        createdDate
        updatedDate
        currentNode {
          id
          name
          order
        }
      }
      steps {
        id
        nodeType
        status
        attempt
        input
        output
        error
        startedAt
        finishedAt
        node {
          id
          name
        }
      }
      createdDate
      updatedDate
    }
  }
`;

export const PROJECT_RUNS = gql`
  query RunNodes(
    $where: RunNodeWhereInput
    $take: Int
    $skip: Int
    $orderBy: [JSONObject]
  ) {
    runNodes(where: $where, take: $take, skip: $skip, orderBy: $orderBy) {
      data {
        id
        status
        context
        subjectType
        subjectId
        project {
          id
        }
        process {
          id
        }
        currentNode {
          id
          name
          nodeType
          formDefinition
          config
        }
        children {
          id
          status
          subjectType
          subjectId
        }
        steps {
          id
          nodeType
          status
          attempt
          output
          error
          startedAt
          finishedAt
          node {
            id
            name
          }
        }
        createdDate
        updatedDate
      }
      count
    }
  }
`;

export const STATUS_DATA = gql`
  query StatusData($run: RunNodeWhereInput!) {
    statusData(run: $run)
  }
`;

export const DATA_ENTITIES = gql`
  query DataEntities {
    dataEntities {
      key
      label
      defaultMode
      defaultFilters
    }
    dataBindingTokens
  }
`;

const projectRuns = { PROJECT_RUN, PROJECT_RUNS, STATUS_DATA, DATA_ENTITIES };

export default projectRuns;
